/**
 * da-product-media-slider.js
 * Swiper.js v11 based product media gallery
 * Main slider synced to thumbnail strip, variant-change support
 */

(function () {
  'use strict';

  function initDaProductMediaSlider() {
    const galleries = document.querySelectorAll('.da-pms-media-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      const sectionId = gallery.dataset.sectionId;
      const mainEl = gallery.querySelector('#da-pms-main-' + sectionId);
      const thumbEl = gallery.querySelector('#da-pms-thumb-' + sectionId);
      const prevBtn = gallery.querySelector('.da-pms-prev');
      const nextBtn = gallery.querySelector('.da-pms-next');

      if (!mainEl) return;

      // ── Thumbnail Swiper ──────────────────────────────────
      let thumbSwiper = null;

      if (thumbEl) {
        thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            768: { spaceBetween: 10 },
            1024: { spaceBetween: 12 },
          },
        });
      }

      // ── Main Swiper ───────────────────────────────────────
      const mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        autoplay: false,
        allowTouchMove: true,
        pagination: {
          el: mainEl.querySelector('.da-pms-pagination'),
          clickable: true,
          dynamicBullets: false,
        },
        thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
        on: {
          slideChange: function () {
            pauseVideos(mainEl);
          },
        },
      });

      // Store swiper on gallery element for variant sync access
      gallery._daPmsSwiper = mainSwiper;

      // ── Custom Prev / Next buttons ────────────────────────
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          mainSwiper.slidePrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          mainSwiper.slideNext();
        });
      }

      // Update nav button disabled state
      function updateNavState() {
        if (prevBtn) {
          prevBtn.classList.toggle('swiper-button-disabled', mainSwiper.isBeginning);
        }
        if (nextBtn) {
          nextBtn.classList.toggle('swiper-button-disabled', mainSwiper.isEnd);
        }
      }

      mainSwiper.on('slideChange', updateNavState);
      updateNavState();

      // ── Pause video on slide change ───────────────────────
      function pauseVideos(container) {
        container.querySelectorAll('video').forEach(function (v) {
          if (!v.paused) v.pause();
        });
      }

      // ── Intercept theme.js VariantSelector.updateMedia() ─
      // The theme moves #product-media-{id} to the first position in [data-main-media].
      // We intercept that via MutationObserver and instead use slideTo().
      const swiperWrapper = mainEl.querySelector('.swiper-wrapper[data-main-media]');
      if (swiperWrapper) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length) {
              // Theme moved a slide to first position — figure out which media it is
              const movedNode = mutation.addedNodes[0];
              const mediaId = movedNode && movedNode.dataset && movedNode.dataset.mediaId;
              if (!mediaId) return;

              // Undo the DOM reorder — put it back via Swiper update
              // Swiper already has the correct slides from initial render
              // We just need to slideTo the correct index
              // Re-read slides after the DOM mutation settles
              requestAnimationFrame(function () {
                mainSwiper.update();
                slideToMedia(mainEl, mainSwiper, mediaId);
              });
            }
          });
        });

        observer.observe(swiperWrapper, { childList: true });
      }
    });
  }

  /**
   * Slide the main swiper to the slide matching the given media ID.
   */
  function slideToMedia(container, swiper, mediaId) {
    const slides = container.querySelectorAll('.da-pms-slide');
    slides.forEach(function (slide, index) {
      if (String(slide.dataset.mediaId) === String(mediaId)) {
        swiper.slideTo(index, 400);
      }
    });
  }

  // ── Boot ──────────────────────────────────────────────────
  if (typeof Swiper !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDaProductMediaSlider);
    } else {
      initDaProductMediaSlider();
    }
  } else {
    window.addEventListener('load', function () {
      if (typeof Swiper !== 'undefined') {
        initDaProductMediaSlider();
      } else {
        console.warn('[da-product-media-slider] Swiper.js not found.');
      }
    });
  }
})();
